import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const wishlistApi = createApi({
  reducerPath: "wishlistApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/v1/wishlist", credentials: "include" }),
  tagTypes: ["Wishlist"],
  endpoints: (builder) => ({
    // Fetch current user's wishlist
    getWishlist: builder.query({
      query: () => "/me",
      providesTags: ["Wishlist"],
    }),

    // Add product to wishlist
    addToWishlist: builder.mutation({
      query: (productId) => ({
        url: "/new",
        method: "POST",
        body: { productId }, // backend expects productId in body
      }),
      invalidatesTags: ["Wishlist"],
    }),

    // Remove product from wishlist
    removeFromWishlist: builder.mutation({
      query: (wishlistId) => ({
        url: `/${wishlistId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Wishlist"],
    }),
  }),
});

export const {
  useGetWishlistQuery,
  useAddToWishlistMutation,
  useRemoveFromWishlistMutation,
} = wishlistApi;
